export enum FieldChangeDataType {
    String = 0,
    Integer = 1,
    Percent = 2,
    Currency = 3,
    Boolean = 4,
    Date = 5,
}
